import { API } from 'aws-amplify';

export const deleteInstitution = async (categoryId: string) => {
  const data = await API.post('AiFormRequest', '/save?key=deletedi', {
    body: {
      categoryId,
      recordCategoryType: 'di', //For DI Submitter API requests, we need to set recordCategoryType to di
    },
  });
  return data;
};